import type { CompanyDTO } from "@shaarp/common";

/**
 * Build the `q` parameter for Google Maps Embed API.
 * Prefers `place_id:` when available, falls back to a text address query.
 * Returns `null` when there is not enough data to display a map.
 */
export function getGoogleMapsEmbedQuery(
  company: Pick<CompanyDTO, "googlePlaceId" | "location">,
): string | null {
  if (company.googlePlaceId) {
    return `place_id:${company.googlePlaceId}`;
  }

  const { address } = company.location;
  if (address.city) {
    const parts = [address.line1, address.zipCode, address.city, address.country].filter(Boolean);
    return encodeURIComponent(parts.join(", "));
  }

  return null;
}
